module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/icoGroup-dec7a7e8e2bbcde84d50c8d4e39a3d4b.svg";